var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { createContext, useContext, useReducer } from 'react';
var AccordionStateContext = createContext(undefined);
var AccordionDispatchContext = createContext(undefined);
var accordionReducer = function (state) {
    return __assign(__assign({}, state), { open: !state.open });
};
export var AccordionProvider = function (_a) {
    var open = _a.open, shouldAnimate = _a.shouldAnimate, shouldMapOpenPropToContent = _a.shouldMapOpenPropToContent, children = _a.children;
    var _b = __read(useReducer(accordionReducer, {
        open: open,
        shouldAnimate: shouldAnimate,
        shouldMapOpenPropToContent: shouldMapOpenPropToContent,
    }), 2), state = _b[0], dispatch = _b[1];
    return (React.createElement(AccordionStateContext.Provider, { value: state },
        React.createElement(AccordionDispatchContext.Provider, { value: dispatch }, children)));
};
export var useAccordionState = function () {
    var context = useContext(AccordionStateContext);
    if (context === undefined) {
        throw new Error('useAccordionState must be used within a AccordionProvider');
    }
    return context;
};
export var useAccordionDispatch = function () {
    var context = useContext(AccordionDispatchContext);
    if (context === undefined) {
        throw new Error('useAccordionDispatch must be used within a AccordionProvider');
    }
    return context;
};
//# sourceMappingURL=AccordionProvider.js.map